import React, { Component, useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'

import { connect } from 'react-redux'
import { postEnrollmentsData, getSISStatus } from '../../actions'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import { getSISImportStatus } from '../../services/saga'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

let enrollmentCSV = []

const EnrollmentsProcess = (props) => {
  const { data, postEnrollmentsData, selectedCourses, courseSectionUserData } =
    props

  const [progress, setProgress] = useState(10)
  const [sisImportID, setSisImportID] = useState(0)
  const [scvErrors, setCsvErrors] = useState([])
  const [errorAttachment, setErrorAttachment] = useState('')

  const [textStatus, setTextStatus] = useState('Processing,Please wait..')

  const enrollmentCSV = []

  const completed = ''

  useEffect(() => {
    // const { data } = this.props;

    enrollmentCSV.push([
      'course_id',
      'user_id',
      'role_id',
      'section_id',
      'status'
    ])

    let role = data.summery.data.filter((data) => data.value == 'role')

    let csvStatus = data.csvActionType

    selectedCourses.map(function (course) {
      return courseSectionUserData.data.map(function (parent) {
        if (typeof parent[course.id] === 'undefined') {
          return false
        }

        return parent[course.id].map(function (item, i) {
          let usersList = item.text.split(',')

          return usersList.map(function (userData) {
            enrollmentCSV.push([
              item.sis_course_id,
              userData.trim(),
              item.role.id,
              item.sis_section_id,
              item.actionType
            ])
          })
        })
      })
    })

    // enrollmentCSV.push([loopCourse.sis_course_id, loopUser.sis_user_id, role[0].id, csvStatus])

    postEnrollmentsData(enrollmentCSV)
  }, [])

  useEffect(() => {
    const interval = setInterval(async () => {
      if (data.sis_status.id && progress !== 100 && progress !== 0) {
        const sisStatus = await getSISImportStatus(
          data.sis_status.id,
          ' Section Level Admin'
        )

        let textStatus = ''
        let completed = 0

        if (sisStatus.workflow_state == 'created') {
          textStatus = 'The request has been created.'
          completed = 40
        }

        if (sisStatus.workflow_state == 'importing') {
          textStatus = 'The request is currently processing.'
          completed = 70
        }

        if (sisStatus.workflow_state == 'imported') {
          textStatus = 'The request has completed successfully.'
          completed = 100
        }

        if (sisStatus.workflow_state == 'imported_with_messages') {
          textStatus = 'CSV error'
          completed = 0

          setCsvErrors(sisStatus.processing_warnings)

          setErrorAttachment(sisStatus.errors_attachment.url)
        }

        setProgress(completed)
        setTextStatus(textStatus)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [data.sis_status, sisImportID, progress])

  return (
    <React.Fragment>
      <Typography variant='subtitle1'>{textStatus}</Typography>

      <LinearProgress variant='determinate' value={progress} />

      {progress == 100 ? (
        <div>
          {' '}
          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>{' '}
        </div>
      ) : (
        ''
      )}

      {errorAttachment !== '' ? (
        <>
          <Alert severity='error'>
            {scvErrors.join(' - ')}

            <a href={errorAttachment} target='_blank'>
              {' '}
              Download Error Attachment{' '}
            </a>
          </Alert>

          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>
        </>
      ) : null}
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin,

    courseSectionUserData: state.CourseLevelAdmin.courseSectionUserData,
    selectedCourses: state.CourseLevelAdmin.summery.courses
  }
}

export default connect(mapStateToProps, { postEnrollmentsData, getSISStatus })(
  EnrollmentsProcess
)
